<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="section-panel-header">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="36" class="mr-3 panel-avatar">
          <v-icon dark small>set_meal</v-icon>
        </v-avatar>
        <div>
          <div class="section-title">Offre Commerciale</div>
          <div class="section-subtitle">Plateaux de fruits de mer & fichiers associés</div>
        </div>
      </div>
      <template v-slot:actions>
        <div class="d-flex align-center mr-2">
          <v-icon x-small :color="plateauxFiltered.length > 0 ? 'success' : 'grey lighten-1'">{{ plateauxFiltered.length > 0 ? 'check_circle' : 'radio_button_unchecked' }}</v-icon>
        </div>
        <v-icon color="primary">$expand</v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>

      <v-row class="mt-3 px-2">
        <!-- Formulaire ajout -->
        <v-col cols="12" md="3">
          <div class="sub-section-title mb-3">
            <v-icon color="primary" small class="mr-2">set_meal</v-icon>Plateaux de fruits de mer
            <v-chip x-small :color="manualPlateaux.length > 0 ? 'success' : 'grey lighten-1'" :dark="manualPlateaux.length > 0" class="ml-2">{{ manualPlateaux.length }}</v-chip>
          </div>
          <v-card outlined class="config-card pa-3">
            <div class="config-card-title mb-3">
              <v-icon small color="primary" class="mr-1">add_circle</v-icon>Ajouter un plateau
            </div>
            <v-text-field
              v-model="plateauName"
              label="Nom du plateau"
              dense outlined
              hide-details="auto"
              :error-messages="duplicatePlateau ? 'Ce plateau existe déjà' : ''"
              :error="duplicatePlateau"
              class="mb-3"
              @keyup.enter="!invalidPlateau && onAdd()"
            />
            <v-btn color="secondary" dark block :disabled="invalidPlateau" @click="onAdd">
              <v-icon left small>add</v-icon>Ajouter
            </v-btn>
          </v-card>
        </v-col>

        <!-- Liste chips plateaux -->
        <v-col cols="12" md="4">
          <div class="sub-section-title mb-3" style="visibility: hidden;">placeholder</div>
          <div v-if="manualPlateaux.length === 0" class="empty-list-hint">
            <v-icon color="grey lighten-1" class="mr-2">set_meal</v-icon>Aucun plateau ajouté
          </div>
          <div v-else class="chips-wrap">
            <v-chip
              v-for="plat in manualPlateaux"
              :key="plat.nom"
              close
              color="primary"
              outlined
              class="mr-2 mb-2"
              @click:close="$emit('remove', plat)"
            >
              <v-icon left small>set_meal</v-icon>{{ plat.nom }}
            </v-chip>
          </div>
        </v-col>

        <!-- Upload fichier -->
        <v-col cols="12" md="5">
          <div class="sub-section-title mb-3">
            <v-icon color="primary" small class="mr-2">upload_file</v-icon>Catalogue (fichier)
            <v-chip x-small :color="uploadedFiles.length > 0 ? 'success' : 'grey lighten-1'" :dark="uploadedFiles.length > 0" class="ml-2">{{ uploadedFiles.length }}</v-chip>
          </div>
          <FileUpload
            :value="files"
            @input="$emit('update:files', $event)"
            :formats="['.xls', '.xlsx', '.doc', '.docx', '.pdf']"
            uploadTitle="Vos plateaux"
            :multiple="true"
            :service="'plateau'"
            :model="model"
            :code="code"
            :loading="loading"
          />
        </v-col>
      </v-row>

    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue'

export default {
  name: 'PlateauxSection',
  components: { FileUpload },
  props: {
    plateaux: { type: Array, default: () => [] },
    files: { type: Object, default: () => ({ files: [] }) },
    model: { type: [Object, Array], default: () => ({}) },
    code: { type: [Number, String], default: null },
    loading: { type: Boolean, default: false },
  },
  data () {
    return {
      plateauName: '',
    }
  },
  computed: {
    manualPlateaux () {
      return this.plateaux.filter(plateau => !plateau.file)
    },
    uploadedFiles () {
      return (this.files && this.files.files) ? this.files.files : []
    },
    plateauxFiltered () {
      const filesPlateaux = this.uploadedFiles.map(file => ({ ...file, date: file.date, enrollId: this.code, nom: file.nom }))
      return this.manualPlateaux.concat(filesPlateaux)
    },
    duplicatePlateau () {
      return this.plateauName.length > 0 &&
        this.plateaux.filter(p => p.nom === this.plateauName).length > 0
    },
    invalidPlateau () {
      return this.plateauName.length < 1 || this.duplicatePlateau
    },
  },
  methods: {
    onAdd () {
      if (this.invalidPlateau) return
      this.$emit('add', this.plateauName, () => { this.plateauName = '' })
    },
  },
}
</script>

<style scoped>
.config-card {
  border-radius: 10px !important;
  border: 1.5px solid #dde5ea !important;
}
.config-card-title {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--v-primary-base);
  display: flex;
  align-items: center;
}
.sub-section-title {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--v-primary-base);
  display: flex;
  align-items: center;
}
.chips-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 8px 0;
  min-height: 48px;
}
.empty-list-hint {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: rgba(0,0,0,0.38);
  padding: 16px 4px;
}
</style>
